// eslint-disable-next-line
console.log('🐶');
